import React from 'react';
import Materia from './materia';

export default function Semestre({semestre, titulo}) {
    
    if(semestre.length < 1){
        return null;
    }
    
    return (            
        <ul className="materia">
            <li className="semes3"><div className="linea_an completa"></div>{titulo}</li>
            { semestre.map( materia => {           
                    return (
                        <Materia key={materia.id} data={materia} />
                    );
                })
            }            
        </ul>
    );
}